import React from 'react';
import { Query } from 'react-apollo';
import gql from 'graphql-tag';
import SuccessionPlanningTile from '../components/Succession/SuccessionPlanningTile';
import SuccessionPlanningTileFallback from '../components/Succession/SuccessionPlanningTileFallback';
import ErrorBoundary from '../components/ErrorBoundary';

const GET_SUCCESSION_PLANNING_STATUS = gql`
  query {
    successionPlanningFormDatum {
      id
      status
      completionPercentage
      currentSection
    }
  }
`;

const SuccessionPlanningTileContainer = () => {
  return (
    <ErrorBoundary fallback={<SuccessionPlanningTileFallback />}>
      <Query query={GET_SUCCESSION_PLANNING_STATUS}>
        {({ loading, error, data }) => {
          if (loading) {
            return (
              <div className="bg-white shadow rounded-lg p-6 animate-pulse">
                <div className="h-6 bg-gray-200 rounded w-3/4 mb-4"></div>
                <div className="h-32 bg-gray-100 rounded mb-4"></div>
                <div className="h-10 bg-gray-200 rounded w-1/2"></div>
              </div>
            );
          }
          
          if (error) {
            console.error('Succession Planning data fetch error:', error);
            return <SuccessionPlanningTileFallback />;
          }
          
          const successionPlanningData = {
            status: data?.successionPlanningFormDatum?.status || 'not_started',
            completionPercentage: data?.successionPlanningFormDatum?.completionPercentage || 0,
            currentSection: data?.successionPlanningFormDatum?.currentSection || ''
          };
          
          return <SuccessionPlanningTile successionPlanningData={successionPlanningData} />;
        }}
      </Query>
    </ErrorBoundary>
  );
};

export default SuccessionPlanningTileContainer; 